import React from "react";
import { useEventListener } from "@sportal/cdk/hooks";

import { history } from "../router/history";

class Lifecycle extends React.Component {
  componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  }

  componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  }

  render() {
    return null;
  }
}

export const Prompt = ({ message, when = true }) => {
  useEventListener("beforeunload", (e) => {
    e.stopImmediatePropagation();
  });

  if (!when) return null;

  const { block } = history;

  return (
    <Lifecycle
      onMount={(self) => {
        self.release = block(message);
      }}
      onUpdate={(self, prevProps) => {
        if (prevProps.message !== message) {
          self.release();
          self.release = block(message);
        }
      }}
      onUnmount={(self) => {
        self.release();
      }}
      message={message}
    />
  );
};
